import React from "react";

import Card from "../ArticleCarousel/Card";
import List from "../../../components/List";
import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Section from "../../../components/Section";

import style from "./style.module.css";

export default function MySavedList(props) {
    const {
        title = "",
    } = props;

    return (
        <Section className={style.mySavedList}>
            {
                title !== "" && (
                    <div className={`${style.sectionTitle}`}>
                        <Title
                            transform="uppercase"
                            tag="h4"
                            className="fontTeko"
                        >
                            {title}
                        </Title>
                        <Spacer size="24" />
                    </div>
                )
            }
            <List
                className={style.row}
                url="/account/saved-list"
                permissionText="Saved List"
                emptyText={`No saved articles`}
                sort={false}
                limit={50}
                itemTemplate={(item) => {
                    return (
                        <Card
                            item={item}
                            onHover={() => { }}
                        />
                    )
                }}
            />
        </Section>
    )
}